<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-type"
  [activeStep]="2"
  [sectionTitle]="translateKey('section.title')"
  [tipsConfig]="!isMobileDevice && tipsConfig"
  [sectionDescription]="sectionDescription"
  [error$]="error$"
  [formGroup]="formGroup"
  (formSubmit)="submit($event)"
>
  <ng-container *ngIf="isMobileDevice">
    <app-tips
      *ngFor="let tips of tipsConfig; let isFirst = first"
      class="block"
      [className]="isFirst ? 'mt-4' : 'mt-3'"
      [variant]="tips.variant"
      [title]="tips.headerKey | translate"
      [tips]="tips.descriptionKey | translate"
    >
    </app-tips>
  </ng-container>

  <app-input-counter
    *ngIf="isBirthday || isProductTest"
    class="mt-6"
    formControlName="plansMaximumCapacity"
    [label]="translateKey('spots.label')"
    [help]="translateKey('spots.help')"
  ></app-input-counter>

  <div class="mt-6">
    <app-organizer-shared-form-plans
      formControlName="plans"
      [editionMode]="
        isBirthday || isProductTest
          ? formPlansEditionMode.FULL
          : formPlansEditionMode.LIGHT
      "
      [translationKeyPrefix]="translationKeyPrefix"
    >
    </app-organizer-shared-form-plans>
  </div>
</app-organizer-shared-form-wrapper>
